var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","title":"Opciones para imprimir","id":"opciones-para-imprimir"}},_vm._l((_vm.opciones_para_imprimir),function(opcion){return _c('b-button',{staticClass:"m-b-15",attrs:{"block":"","variant":"primary"},on:{"click":function($event){return _vm.clicked(opcion)}}},[_vm._v(" "+_vm._s(opcion.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }